import React from "react";

const Loading = () => (
  <div className="center-screen fullpage-loader">
    <div className="loader"></div>
  </div>
);

export default Loading